// ドキュメントID（UUID）の正規表現
const regex: RegExp = /(\{?[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\}?)?\/(.+)/;

// オブジェクトキーに含まれる属性
export type SplitedObjectKey = {
    prefix: string;
    tenantId: string;
    serialId: string;
    documentId: string;
    documentName: string;
    documentPath: string; // 正確な表現でないが"${documentId}/${documentName}"を意味するものとして扱う
};

// オブジェクトキーを分割する関数
export function splitObjectKey(objectKey: string): SplitedObjectKey {
    const parts = objectKey.split('/');

    // 必要な項目のチェック
    if (parts.length < 5) {
        throw new Error('Invalid object key format');
    }

    const documentPath: string = parts.slice(4).join('/');

    const match: RegExpMatchArray | null = documentPath.match(regex);

    const result: SplitedObjectKey = {
        prefix: parts.slice(0, 2).join('/'),
        tenantId: parts[2],
        serialId: parts[3],
        documentId: match ? match[1] : '',
        documentName: match ? match[2] : documentPath,
        documentPath: documentPath,
    };

    return result;
}

// ${ドキュメントID}/${ドキュメント名}を分割する関数
export function splitDocumentPath(documentPath: string): { documentId: string; documentName: string } {
    const match: RegExpMatchArray | null = documentPath.match(regex);
    const result: { documentId: string; documentName: string } = {
        documentId: match ? match[1] : '',
        documentName: match ? match[2] : documentPath,
    };

    return result;
}
